<template>
  <div id="app">
    <header-section></header-section>
    <header-nav></header-nav>
    <main>
      <flash
        ref="flash"
      ></flash>
      <router-view></router-view>
    </main>
    <footer-section></footer-section>
  </div>
</template>

<script>
import humanizeString from 'humanize-string'

import Auth from '@/components/Auth'
import Flash from '@/components/Flash'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import HeaderNav from '@/components/HeaderNav'

import AuthStore from '@/stores/AuthStore'
import FlashStore from '@/stores/FlashStore'
import UserStore from '@/stores/UserStore'

export default {
  name: 'app',

  data () {
    return {
      baseTitle: 'PuzzleAnywhere Admin',
      currentUser: UserStore.state
    }
  },

  computed: {
    admin () {
      return this.role === 'admin'
    },

    support () {
      return this.role === 'support_user'
    },

    role () {
      if (this.currentUser.id) {
        return this.currentUser.role_alias
      }
    }
  },

  components: {
    'auth': Auth,
    'flash': Flash,
    'header-section': Header,
    'header-nav': HeaderNav,
    'footer-section': Footer
  },

  displayDate () {
    if (this.date) {
      return this.date.displayDate()
    }
  },

  created () {
    // Check if route requires auth and that the user is logged in.
    AuthStore.dispatch('loggedIn').then(resp => {
      if (!resp) {
        this.$router.push({ name: 'sign_in' })
      } else {
        this.setCurrentUser(resp)
      }
    })

    this.setTitle(this.$route)
    this.$router.afterEach(this.setTitle)

    this.$store.dispatch(
      `SettingModule/refreshIfStale`, 'settings'
    ).catch(this.$root.processErrors)

    this.$on('processErrors', this.processErrors)
    this.$root.$on('showErrors', this.showErrors)
  },

  methods: {
    setTitle (route) {
      const subtitle = this.baseTitle + ' - ' + humanizeString(route.name)

      document.getElementsByTagName('title')[0].innerText = subtitle
    },

    // Generic handling of errors.
    // THIS IS NOT THE SAME AS $root.processErrors!!
    // This is being deprecated in favor for `jsonapi-helper#processErrors`.
    processErrors (resp) {
      if (!resp.body) {
        // Handle unauthorized responses.
        if (resp.status === (401 || 403)) {
          this.$router.push({
            name: 'login'
          })
        // Known error.
        } else if (resp.status) {
          FlashStore.errors(['An error occurred: ' + resp.statusText + ' (' + resp.status + ')'])
        // Unknown error.
        } else {
          FlashStore.errors(['A connection error occurred.'])
        }
      } else {
        const errMsg = resp.body.info || resp.body.exception || resp.statusText

        FlashStore.errors([errMsg + ' (' + resp.status + ')'])
      }

      const flash = document.getElementById('flash')
      flash.scrollIntoView(true)
    },

    setCurrentUser (user) {
      this.currentUser = {
        id: user.id,
        name: user.name,
        role_alias: user.role_alias
      }
    },

    showErrors (err) {
      this.$root.loading = false

      FlashStore.error(err)
    }
  }
}
</script>

<style>
@import './assets/css/screen.css';

button[type="button"] div,
button[type="submit"] div {
  display: inline-block;
}

.alert p:last-child {
  margin-bottom: 0;
}

main nav {
  margin-top: 0;
  margin-bottom: 1em;
}

.nav {
  border-top: 0
}

a.list-group-item:hover {
  background-color: rgba(252, 251, 178, 0.8);
}

.paged-key span {
  margin: 0 0.25rem
}
</style>



// WEBPACK FOOTER //
// src/App.vue